var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _ellipse2, _path16, _path17, _path18, _path19, _path20, _ellipse3, _line, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 161,
    viewBox: "0 0 200 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 161H2.96772C1.06783 157.069 0 152.64 0 147.957C0 137.435 5.38851 128.203 13.4931 122.997C11.4297 120.473 10.1875 117.221 10.1875 113.671C10.1875 105.644 16.5404 99.1371 24.3772 99.1371C29.2412 99.1371 33.5336 101.644 36.0902 105.465C40.2943 101.534 45.8883 99.1371 52.0289 99.1371C53.9177 99.1371 55.7547 99.3639 57.5154 99.7923C58.1301 86.9754 68.4703 76.7771 81.136 76.7771C94.1973 76.7771 104.786 87.6223 104.786 101C104.786 101.866 104.741 102.722 104.655 103.564C107.407 101.708 110.703 100.628 114.245 100.628C119.091 100.628 123.476 102.649 126.64 105.914C131.323 96.1602 141.12 89.4478 152.448 89.4478C168.323 89.4478 181.192 102.629 181.192 118.889C181.192 124.698 179.549 130.114 176.714 134.676C189.22 137.085 198.868 147.792 200 161Z",
    fill: "url(#paint0_linear_479_2810)",
    fillOpacity: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.508,
    cy: 45.0972,
    rx: 3.62319,
    ry: 3.65665,
    fill: "#F9C835",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.42 22.4261L178.217 28.2767",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.421 28.2766L178.218 22.426",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.435 7.79923L149.232 13.6499",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.435 13.6498L149.233 7.79918",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2031 70.6936L13.0002 76.5443",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20348 76.5442L13.0006 70.6936",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.435 37.0525L49.2321 42.9032",
    stroke: "#304455",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4354 42.9031L49.2325 37.0525",
    stroke: "#304455",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9277 6.33671L63.7248 12.1873",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9281 12.1872L63.7252 6.33653",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9131 81.6652L84.058 78.0071V104.208L73.9131 107.26V81.6652Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.087 81.6652L115.942 78.0071V104.208L126.087 107.26V81.6652Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 112.162C111.206 112.162 120.29 87.2776 120.29 56.5811C120.29 25.8845 111.206 1 100 1C88.7945 1 79.7104 25.8845 79.7104 56.5811C79.7104 87.2776 88.7945 112.162 100 112.162ZM87.0306 113.111C86.1309 113.111 85.342 113.711 85.1026 114.579L83.3809 120.817C83.0294 122.091 83.9876 123.349 85.3089 123.349H114.569C115.878 123.349 116.834 122.113 116.505 120.846L114.882 114.607C114.653 113.726 113.858 113.111 112.947 113.111H87.0306Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1026 114.579L84.1387 114.313L84.1387 114.313L85.1026 114.579ZM83.3809 120.817L84.3449 121.083L84.3449 121.083L83.3809 120.817ZM116.505 120.846L117.473 120.594L117.473 120.594L116.505 120.846ZM114.882 114.607L113.915 114.859L113.915 114.859L114.882 114.607ZM119.29 56.5811C119.29 71.8437 117.03 85.6176 113.408 95.5399C111.595 100.505 109.461 104.453 107.141 107.141C104.819 109.832 102.402 111.162 100 111.162V113.162C103.201 113.162 106.123 111.382 108.655 108.448C111.19 105.511 113.428 101.319 115.287 96.2257C119.008 86.0316 121.29 72.015 121.29 56.5811H119.29ZM100 2C102.402 2 104.819 3.33029 107.141 6.02121C109.461 8.70917 111.595 12.657 113.408 17.6222C117.03 27.5445 119.29 41.3184 119.29 56.5811H121.29C121.29 41.1472 119.008 27.1305 115.287 16.9364C113.428 11.8434 111.19 7.65161 108.655 4.71446C106.123 1.78027 103.201 0 100 0V2ZM80.7104 56.5811C80.7104 41.3184 82.9705 27.5445 86.5926 17.6222C88.4051 12.657 90.5397 8.70917 92.8596 6.02121C95.1821 3.33029 97.5984 2 100 2V0C96.7993 0 93.878 1.78027 91.3455 4.71446C88.8106 7.65161 86.573 11.8434 84.7138 16.9364C80.9925 27.1305 78.7104 41.1472 78.7104 56.5811H80.7104ZM100 111.162C97.5984 111.162 95.1821 109.832 92.8596 107.141C90.5397 104.453 88.4051 100.505 86.5926 95.5399C82.9705 85.6176 80.7104 71.8437 80.7104 56.5811H78.7104C78.7104 72.015 80.9925 86.0316 84.7138 96.2257C86.573 101.319 88.8106 105.511 91.3455 108.448C93.878 111.382 96.7993 113.162 100 113.162V111.162ZM86.0666 114.845C86.1863 114.411 86.5807 114.111 87.0306 114.111V112.111C85.6811 112.111 84.4977 113.012 84.1387 114.313L86.0666 114.845ZM84.3449 121.083L86.0666 114.845L84.1387 114.313L82.417 120.551L84.3449 121.083ZM85.3089 122.349C84.6482 122.349 84.1691 121.72 84.3449 121.083L82.417 120.551C81.8897 122.462 83.327 124.349 85.3089 124.349V122.349ZM114.569 122.349H85.3089V124.349H114.569V122.349ZM115.537 121.098C115.702 121.731 115.224 122.349 114.569 122.349V124.349C116.533 124.349 117.967 122.494 117.473 120.594L115.537 121.098ZM113.915 114.859L115.537 121.098L117.473 120.594L115.85 114.356L113.915 114.859ZM112.947 114.111C113.402 114.111 113.8 114.418 113.915 114.859L115.85 114.356C115.506 113.034 114.313 112.111 112.947 112.111V114.111ZM87.0306 114.111H112.947V112.111H87.0306V114.111Z",
    fill: "#4A4A4A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.9999,
    cy: 54.6046,
    rx: 10.1449,
    ry: 10.2386,
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9826 34.8586H116.568",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100 80.9324V107.26",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100 129.2V145.289",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7534 129.2V135.051",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107.247 129.2V139.439",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.9999,
    cy: 54.6046,
    rx: 10.1449,
    ry: 10.2386,
    fill: "#F9C835",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 63.3188,
    y1: 159.845,
    x2: 136.681,
    y2: 159.845,
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_479_2810",
    x1: 100,
    y1: 76.7771,
    x2: 100,
    y2: 161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7DAF1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7DAF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.5ee2db7a64b483f0cfaf7bcf0db87100.svg";
export { ForwardRef as ReactComponent };